// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.common-btn{
  display: flex;
  align-items: center;
  justify-content: center;
border: none;
  border-radius: 5px;
  background: rgb(195, 155, 34);
  padding: 10px;
    padding-right: 10px;
    padding-left: 10px;
  color: #fff;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/components/common/Button/Button.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB,YAAY;EACV,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;IACX,mBAAmB;IACnB,kBAAkB;EACpB,WAAW;EACX,qCAAqC;EACrC,gBAAgB;AAClB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');\n\n.common-btn{\n  display: flex;\n  align-items: center;\n  justify-content: center;\nborder: none;\n  border-radius: 5px;\n  background: rgb(195, 155, 34);\n  padding: 10px;\n    padding-right: 10px;\n    padding-left: 10px;\n  color: #fff;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
